import { Component, OnInit } from '@angular/core';

import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ChatService } from '@shared/services/api/chat.service';

@Component({
  selector: 'app-chat-user-sidebar',
  templateUrl: './chat-user-sidebar.component.html'
})
export class ChatUserSidebarComponent implements OnInit {
  // Public
  public userProfile;

  /**
   * Constructor
   *
   * @param {ChatService} _chatService
   * @param {CoreSidebarService} _coreSidebarService
   */
  constructor(private _chatService: ChatService, private _coreSidebarService: CoreSidebarService) {}

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle Sidebar
   *
   * @param name
   */
  toggleSidebar(name) {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  /**
   * Update User Status
   */
  updateUserStatus() {
    this._chatService.updateUserProfile(this.userProfile);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.userProfile = this._chatService.userProfile;
  }
}
